import { render, staticRenderFns } from "./Internal-History-Detail.vue?vue&type=template&id=363a6d30"
import script from "./Internal-History-Detail.vue?vue&type=script&lang=js"
export * from "./Internal-History-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports